module.exports = __webpack_public_path__ + "static/bio-f4b7368874ae1ddceacfda0713608c9d.jpg";